<template>
  <div class="allOrders container">
    <!-- tab -->
    <orderAuditHead
      @setCurrentMenu="setCurrentMenu"
      :countOrder="countOrder"
      :approvedTotal="0"
      ref="orderAuditHead"
    ></orderAuditHead>
    <!-- 搜索 -->
    <div class="serachCriteria">
      <e-search
        class="search"
        :width="width"
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
        :count="10"
      ></e-search>
    </div>
    <!-- table -->
    <allOrder :records="records" :selectOrder="selectOrder"></allOrder>
    <!-- 分页 -->
    <div class="orderPage" v-if="records.length > 0">
      <el-pagination
        style="margin-top: 20px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="formInline.pageNum"
        :total="formInline.total"
        :page-size.sync="formInline.pageSize"
        prev-text="上一页"
        next-text="下一页"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import orderAuditHead from './orderAuditHead';
import allOrder from './allOrder';
import eSearch from '@/modules/projectA/components/common/e-search.vue';
import utils from '@/modules/projectA/utils/utils';
import Api from '@/modules/projectA/api/auditManagement/index';
import orApi from '@/modules/projectA/api/order';

export default {
  name: 'allOrders',
  props: {
    changeOrderHandle: {
      type: Function,
      require: true,
    },
  },
  components: { allOrder, eSearch, orderAuditHead },

  data() {
    return {
      countOrder: {
        allCount: 0,
        approveCount: 0,
      },
      records: [],
      currentPage: '0',
      formInline: {
        pageSize: 5,
        pageNum: 1,
        total: 0,
        orderNo: null, // 订单编号
        supplierCompany: null, // 供应商名称
        startTime: null, // 下单时间-开始
        endTime: null, // 下单时间-结束
        memberRealName: null, // 下单人
        organizationName: null, // 所属组织
        startAmount: null, // 订单总价-起始订单金额
        endAmount: null, // 订单总价-结束订单金额
        orderStatus: null, // 订单状态
      },
      width: {
        labelWidth: 108,
        itemWidth: 200,
      },
      listTypeInfo: {
        orderStatus: [
          { id: null, name: '全部状态' },
          { id: 12, name: '待审批' },
          { id: '31,32', name: '待发货' },
          { id: 4, name: '待收货' },
          { id: '21,22', name: '待付款' },
          { id: 6, name: '交易成功 ' },
        ],
      },
      filterInfo: {
        data: {
          orderNo: null, //订单编号
          supplierCompany: null, //供应商名称
          time: null,
          startTime: null,
          endTime: null,
          memberRealName: null, //下单人姓名
          orderStatus: null, // 订单状态
          endAmount: null,
          startAmount: null,
        },
        fieldList: [],
        btnStyle: [
          { icon: 'el-icon-refresh', text: '重置' },
          { icon: 'el-icon-search', text: '查询', type: 'primary' },
        ],
      },
      allOrder: [
        { label: '订单编号', type: 'input', value: 'orderNo' },
        { label: '供应商名称', type: 'input', value: 'supplierCompany' },
        {
          label: '下单时间',
          type: 'date',
          value: 'time',
          dateType: 'datetimerange',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          defaultTime: ['00:00:00', '23:59:59'],
        },
        { label: '下单人', type: 'input', value: 'memberRealName' },
        { label: '下单部门', type: 'input', value: 'organizationName' },
        {
          label: '订单总价',
          type: 'numRange',
          value: 'amount',
          value1: 'startAmount',
          value2: 'endAmount',
        },
      ],
      waitApprover: [
        { label: '订单编号', type: 'input', value: 'orderNo' },
        { label: '供应商名称', type: 'input', value: 'supplierCompany' },
        {
          label: '下单时间',
          type: 'date',
          value: 'time',
          dateType: 'datetimerange',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          defaultTime: ['00:00:00', '23:59:59'],
        },
        { label: '下单人', type: 'input', value: 'memberRealName' },
        { label: '所属组织', type: 'input', value: 'organizationName' },
        {
          label: '订单总价',
          type: 'numRange',
          value: 'amount',
          value1: 'startAmount',
          value2: 'endAmount',
        },
        {
          label: '订单状态',
          type: 'select',
          value: 'orderStatus',
          list: 'orderStatus',
        },
      ],
      //
      approvedTotal: 0,
    };
  },
  mounted() {
    // 判断是否从商城消息中心跳转过来的？ true 获取订单编号查询, false null
    let orderCode = utils.getUrlKey('orderCode');
    if (orderCode != 'undefined') {
      this.formInline.orderNo = orderCode;
      this.filterInfo.data.orderNo = orderCode;
    }
    // 待审批订单列表查询-分页
    this.selectOrder();
    this.filterInfo.fieldList = this.allOrder;
  },
  methods: {
    setCurrentMenu(param) {
      this.currentPage = param;
      console.log(this.currentPage, 'currentPage');
      this.filterInfo.data = {
        orderNo: null, //订单编号
        supplierCompany: null, //供应商名称
        time: null,
        startTime: null,
        endTime: null,
        memberRealName: null, //下单人姓名
        orderStatus: null, // 订单状态
        endAmount: null,
        startAmount: null,
      };
      this.formInline = {
        orderNo: null, // 订单编号
        supplierCompany: null, // 供应商名称
        startTime: null, // 下单时间-开始
        endTime: null, // 下单时间-结束
        memberRealName: null, // 下单人
        organizationName: null, // 所属组织
        startAmount: null, // 订单总价-起始订单金额
        endAmount: null, // 订单总价-结束订单金额
        orderStatus: null, // 订单状态
        pageNum: 1,
        pageSize: 5,
      };
      this.formInline.pageNum = 1;
      this.formInline.pageSize = 5;
      if (param == '0') {
        this.filterInfo.fieldList = this.allOrder;
        this.selectOrder();
      } else {
        // 待审批
        this.filterInfo.fieldList = this.waitApprover;
        this.getApproveOrderPageHas();
      }
    },
    //分页点击查询
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      if (this.currentPage === '0') {
        this.selectOrder();
      } else {
        this.getApproveOrderPageHas();
      }
    },
    handleSizeChange(val) {
      this.formInline.pageNum = 1;
      this.formInline.pageSize = val;
      if (this.currentPage === '0') {
        this.selectOrder();
      } else {
        this.getApproveOrderPageHas();
      }
    },

    // 搜索
    handleFilter(val) {
      console.log(val, 'parseTime');

      this.formInline = {
        orderNo: val.orderNo, // 订单编号
        supplierCompany: val.supplierCompany, // 供应商名称
        startTime: val.time ? val.time[0] : '', // 下单时间-开始
        endTime: val.time ? val.time[1] : '', // 下单时间-结束
        memberRealName: val.memberRealName, // 下单人
        organizationName: val.organizationName, // 所属组织
        startAmount: val.startAmount, // 订单总价-起始订单金额
        endAmount: val.endAmount, // 订单总价-结束订单金额
        orderStatus: val.orderStatus,
        pageNum: 1,
        pageSize: 5,
        time: [],
      };

      if (this.currentPage === '0') {
        this.selectOrder();
      } else {
        console.log(this.formInline, 'this.formInline');
        this.getApproveOrderPageHas();
      }
    },
    //重置
    handleReset() {
      this.filterInfo.data.orderNo = null;
      this.formInline = {
        orderNo: null, // 订单编号
        supplierCompany: null, // 供应商名称
        startTime: null, // 下单时间-开始
        endTime: null, // 下单时间-结束
        memberRealName: null, // 下单人
        organizationName: null, // 所属组织
        startAmount: null, // 订单总价-起始订单金额
        endAmount: null, // 订单总价-结束订单金额
        orderStatus: null, // 订单状态 待审批
        pageNum: 1,
        pageSize: 5,
      };
      if (this.currentPage === '0') {
        this.selectOrder();
      } else {
        this.getApproveOrderPageHas();
      }
    },
    async getHandleData(res) {
      this.formInline.total = res.data.total;
      if (res.data.records instanceof Array) {
        this.records = JSON.parse(JSON.stringify(res.data.records));
        //获取审核人
        if (this.records.length > 0) {
          let approveFlag = false;
          let approveRes = {};
          approveRes = await Api.approveName({
            orderIdList: this.records.map(item => item.orderId),
          });
          if (approveRes.code == '200' && approveRes.data instanceof Array) {
            if (approveRes.data.length > 0) {
              approveFlag = true;
            }
          } else {
            this.$message.error(res.message);
          }

          for (let i = 0; i < this.records.length; i++) {
            if (!this.records[i].skuJson) {
              continue;
            }

            //转化图片
            this.records[i].skuJson = JSON.parse(this.records[i].skuJson);
            //添加审批人
            if (approveFlag) {
              approveRes.data.forEach(approveItem => {
                if (this.records[i].orderId == approveItem.orderId) {
                  this.$set(this.records[i], 'approveRealName', approveItem.approveRealName);
                  this.$set(
                    this.records[i],
                    'isShowApproveButton',
                    approveItem.isShowApproveButton
                  );
                }
              });
            }

            //处理采购申请号多个的问题
            if (
              this.records[i].purchaseRequisitionNo &&
              (this.records[i].orderSource == 3 || this.records[i].orderSource == 31)
            ) {
              let requestNoList = this.records[i].purchaseRequisitionNo.split(',');
              let arr = [];
              if (requestNoList.length > 2) {
                let index = this.records[i].purchaseRequisitionNo.indexOf(',');
                while (index != -1) {
                  arr.push(index);
                  index = this.records[i].purchaseRequisitionNo.indexOf(',', index + 1);
                  if (arr.length == 2) {
                    break;
                  }
                }
                this.$set(
                  this.records[i],
                  'moreRequestNo',
                  this.records[i].purchaseRequisitionNo.substring(arr[0] + 1)
                );
                this.$set(this.records[i], 'purchaseRequisitionNo', requestNoList[0]);
              } else {
                this.$set(
                  this.records[i],
                  'purchaseRequisitionNo',
                  this.records[i].purchaseRequisitionNo
                );
              }
            }

            //判断采购商城订单      入参 供应商id，校验 权限 true不显示，false 显示
            let res = await orApi.companyWhetherSystemIntegrationByCompanyId({
              companyId: this.records[i].supplierCompanyId,
              createTime: this.records[i].submitTime,
            });
            this.$set(this.records[i], 'systemFlag', res.data);
          }
        }
      } else {
        this.$message.error('返回字段类型不规范');
      }
    },
    async selectOrder() {
      const params = { ...this.formInline };
      params.orderStatus = 12;
      this.records = [];
      //订单列表
      let res = await Api.waitApproveOrderPage(params);
      if (res.code == '200') {
        this.countOrder.approveCount = res.data.total; //待审批
        this.getHandleData(res);
      } else {
        this.$message.error(res.message);
      }
    },

    // 已审批列表
    async getApproveOrderPageHas() {
      try {
        const params = { ...this.formInline };
        if (params.orderStatus && typeof params.orderStatus === 'string') {
          params.orderStatusList = params.orderStatus.split(',').map(item => Number(item));
          delete params.orderStatus;
        }
        console.log(params, '参数');

        this.records = [];
        const res = await Api.approveOrderPageHas(params);
        if (res.code == '200') {
          this.approvedTotal = res.data.total;
          this.getHandleData(res);
        } else {
          this.$message.error(res.message);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/css/theme.scss';
.allOrders {
  background: #fff;
}
.serachCriteria {
  background: #fff;
  position: relative;
  top: -1px;
  padding: 6px 10px 20px 14px;
  border: 1px solid $border-color;
  box-sizing: border-box;
  margin-bottom: 50px;
  min-height: 110px;
}
.search {
  margin-top: 10px;
}
.orderPage {
  ::v-deep .el-pagination {
    margin-top: 50px;
    text-align: center;
  }
  ::v-deep.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ea9200;
  }
}
</style>
